import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Input, Select, Icon, message, Steps } from 'antd';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import {
  ModalBody,
  ModalContainer,
  InputLabel,
  Container,
  InputContainer,
  WarningLabel,
  StepsAction,
  AdduserSec,
  InputRow,
} from './styles';
import { addNewUser, updateUser } from '../../utils/services/userAPI';
import { getLdapUsers, addLdapUsers } from '../../utils/services/ldapAPI';
import TeamPermission from '../TeamPermission';
import REGEX from '../../utils/regex';
import { withTranslation } from 'react-i18next';
import { ADD_USER_MODAL as addTrans, UPDATE_USER_MODAL as updateTrans  } from './translationValues';
import { AppStoreContext } from '../../context/appStoreContext';

const { Option } = Select;

const NAMESPACES = ['ADD_USER_MODAL', 'UPDATE_USER_MODAL'];

const ADD_USER_MODAL = 'ADD_USER_MODAL';
const UPDATE_USER_MODAL = 'UPDATE_USER_MODAL';
const TEAM_SELECTABLE_ROLES = [4, 5, 16, 17];

const AddUserModal = props => {
  const {
    visible,
    onCancel,
    targetUser,
    isEditable,
    userRoleData,
    groupPermission,
    isInitialLDAPConfig,
    t,
  } = props;
  const { firstName, lastName, email, id, roles, aType, adid, displayName, primary, status } = targetUser;
  const [userDetails, setUserDetails] = useState({
    firstName,
    lastName,
    email,
    id,
    roles,
    aType,
    adid,
    displayName,
    primary,
    status,
  });
  const [ldapUserName, setLdapUserName] = useState();
  const [isLoading, setLoading] = useState(false);
  const [Validmail, setValidmail] = useState(isEditable);
  const [selectedIds, setSelectedIds] = useState(targetUser.resourceGroupPermission || []);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [isEditUserName, setIsEditUserName] = useState(false);
  const [isPermissionChanged, setIsPermissionChanged] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [ldapUsers, setLdapUsers] = useState([]);
  const [isLdap, setIsLdap] = useState(false);
  const [warningText, setWarningText] = useState({
    firstName: '',
    lastName: '',
    email: '',
    roles: '',
    ldapUser: '',
  });
  const { Step } = Steps;
  const steps = [
    {
      title: t(addTrans.USER_DETAILS_STEP.key, addTrans.USER_DETAILS_STEP.value),
    },
    {
      title: t(addTrans.ROLES_AND_PERMISSIONS_STEP.key, addTrans.ROLES_AND_PERMISSIONS_STEP.value),
    },
  ];
  const { userDetails: { userType: userType }, isEnterprise } = useContext(AppStoreContext);

  const MAX_CHAR_LIMIT = 45;

  useEffect(() => {
    (async () => {
      if (!isEditable && isEnterprise && !isInitialLDAPConfig) {
        let ldapresponse = await getLdapUsers();
        if (ldapresponse) {
          setLdapUsers(ldapresponse.data);
        }
      }
    })();
    // eslint-disable-next-line
  }, []);

  const saveUser = async () => {
    let response;
    let payload = userDetails;
    payload.userType = userType;
      payload.resourceGroupPermission =
        TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role)) ? selectedIds : [];
    payload.lastName = userDetails?.lastName ? userDetails.lastName : '';
    if (userDetails.aType === 'ad') {
      payload.firstName = null;
      payload.lastName = null;
      payload.email = null;
    }
    setLoading(true);
    if (!isEditable) {
      response = await addNewUser(payload);
    } else {
      response = await updateUser(payload);
    }
    if (response) {
      setLoading(false);
      if (response && response.errors && response.errors.length === 0) {
        let responseType = isEditable 
              ? t(updateTrans.USER_UPDATED_SUCCESS_MESSAGE.key, updateTrans.USER_UPDATED_SUCCESS_MESSAGE.value) 
              : t(addTrans.USER_INVITED_SUCCESS_MESSAGE.key, addTrans.USER_INVITED_SUCCESS_MESSAGE.value, { emailId: userDetails.email });
        message.success(responseType);
        onCancel(isEditable ? 'Updated' : 'Added', response.id, payload);
      } else {
        if (response.errors[0].code === 816) {
        } else {
          setWarningText({
            ...warningText,
            email:
              response.errors[0].code === 802
                ? t(addTrans.INVALID_EMAIL_ERROR.key, addTrans.INVALID_EMAIL_ERROR.value)
                : response.errors[0].code === 803
                ? t(addTrans.EXISTS_EMAIL_ERROR.key, addTrans.EXISTS_EMAIL_ERROR.value)
                : response.errors[0].code === 805
                ? t(addTrans.EMPTY_EMAIL_ERROR.key, addTrans.EMPTY_EMAIL_ERROR.value)
                : '',
            roles: response.errors[0].code === 808 ?
            t(addTrans.EMPTY_ROLES_ERROR.key, addTrans.EMPTY_ROLES_ERROR.value) : '',
            firstName: response.errors[0].code === 804 ? 
            isEditable ? t(`${UPDATE_USER_MODAL}: ${updateTrans.EMPTY_FIRST_NAME_ERROR.key}`, updateTrans.EMPTY_FIRST_NAME_ERROR.value) 
            : t(`${ADD_USER_MODAL}: ${addTrans.EMPTY_FIRST_NAME_ERROR.key}`, addTrans.EMPTY_FIRST_NAME_ERROR.value) : '',
          });
          setCurrentStep(currentStep - 1);
        }
      }
    }
  };

  const saveLdapUser = async () => {
    let payload = {
      aType: isLdap ? "LDAP" : undefined,
      adid: isEditable ? adid : selectedUser?.adid,
      displayName: isEditable ? displayName : ldapUserName,
      roles: userDetails.roles,
      resourceGroupPermission:
        TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role)) ? selectedIds : [],
    };
    setLoading(true);
    if (userType === 'client') {
      let response = await addLdapUsers(payload);
      if (response) {
        setLoading(false);
        if (response && response.errors && response.errors.length === 0) {
          message.success(t(addTrans.LDAP_USER_ADDED_SUCCESS_MESSAGE.key, addTrans.LDAP_USER_ADDED_SUCCESS_MESSAGE.value));
          onCancel('LDAP_User_Added', response.data.id, response.data);
        }
      }
    }
  };

  const handleChange = e => {
    const { value, name } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
    if(name === 'firstName') {
      setWarningText({
        ...warningText,
        firstName: value.length < 1 ? 
        isEditable ? t(`${UPDATE_USER_MODAL}: ${updateTrans.EMPTY_FIRST_NAME_ERROR.key}`, updateTrans.EMPTY_FIRST_NAME_ERROR.value)
          : t(`${ADD_USER_MODAL}: ${addTrans.EMPTY_FIRST_NAME_ERROR.key}`, addTrans.EMPTY_FIRST_NAME_ERROR.value) 
        : value.length > MAX_CHAR_LIMIT ? t(`${ADD_USER_MODAL}: ${addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.key}`, addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.value) : '',
      });
    }
    if(name === 'lastName') {
      setWarningText({
        ...warningText,
        lastName: value.length > MAX_CHAR_LIMIT ? t(`${ADD_USER_MODAL}: ${addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.key}`, addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.value) : '',
      });
    }
    if (name === 'email') {
      if (value.length > 0) {
        validateEmail(value);
      } else {
        setWarningText({
          ...warningText,
          email: value.length > 0 ? '' : t(addTrans.EMPTY_EMAIL_ERROR.key, addTrans.EMPTY_EMAIL_ERROR.value),
        });
      }
    }
  };

  const validateEmail = value => {
    let trimedTag = value.trim().replace(/\s/g, '');
    if (trimedTag.length > 0) {
      const isValidEmail = REGEX.EMAIL.test(trimedTag);
      setWarningText({
        ...warningText,
        email: !isValidEmail ? t(addTrans.INVALID_EMAIL_ERROR.key, addTrans.INVALID_EMAIL_ERROR.value) : '',
      });
      setValidmail(isValidEmail);
    }
  };

  const handleKeyPress = e => {
    if (
      userDetails.firstName &&
      userDetails.lastName &&
      userDetails.email &&
      userType &&
      userDetails.roles &&
      e.key === 'Enter'
    ) {
      saveUser();
    }
  };

  const onSuccess = (ids, index) => {
    setSelectedIds(ids);
    setSelectedIndex(index);
    let permissionChanged = selectedIds === ids ? false : true;
    setIsPermissionChanged(permissionChanged);
  };

  const validateUser = () => {
    if (targetUser?.aType !== 'ad') {
      if (
        userDetails.firstName &&
        userDetails.email &&
        Validmail &&
        userDetails.roles?.length > 0 &&
        !TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role))
      ) {
        saveUser();
        setWarningText({
          permission: '',
        });
      } else if (
        userDetails.firstName &&
        userDetails.email &&
        Validmail &&
        selectedIds?.length > 0 &&
        userDetails.roles?.length > 0
      ) {
        saveUser();
      } else {
        setWarningText({
          firstName: !userDetails.firstName ?
          isEditable ? t(`${UPDATE_USER_MODAL}: ${updateTrans.EMPTY_FIRST_NAME_ERROR.key}`, updateTrans.EMPTY_FIRST_NAME_ERROR.value)
          : t(`${ADD_USER_MODAL}: ${addTrans.EMPTY_FIRST_NAME_ERROR.key}`, addTrans.EMPTY_FIRST_NAME_ERROR.value) : '',
          email: !userDetails.email
            ? t(addTrans.EMPTY_EMAIL_ERROR.key, addTrans.EMPTY_EMAIL_ERROR.value)
            : !Validmail
            ? t(addTrans.INVALID_EMAIL_ERROR.key, addTrans.INVALID_EMAIL_ERROR.value)
            : '',
          roles: !userDetails.roles || userDetails.roles?.length === 0 ? 
          t(addTrans.EMPTY_ROLES_ERROR.key, addTrans.EMPTY_ROLES_ERROR.value) : '',
          permission: selectedIds?.length === 0 ? 
          t(addTrans.TEAM_PERMISSIONS_ERROR.key, addTrans.TEAM_PERMISSIONS_ERROR.value) : '',
        });
      }
    } else if (targetUser?.aType === 'ad') {
      if (
        userType === 'client' &&
        !TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role))
      ) {
        saveUser();
        setWarningText({
          permission: '',
        });
      } else if (selectedIds?.length > 0 && userDetails.roles?.length > 0) {
        saveUser();
      } else {
        setWarningText({
          roles: !userDetails.roles || userDetails.roles?.length === 0 ? 
          t(addTrans.EMPTY_ROLES_ERROR.key, addTrans.EMPTY_ROLES_ERROR.value) : '',
          permission: selectedIds?.length === 0 ?
          t(addTrans.TEAM_PERMISSIONS_ERROR.key, addTrans.TEAM_PERMISSIONS_ERROR.value) : '',
        });
      }
    }
    selectedIds?.length === 0 && setIsPermissionChanged(true);
  };

  const validateUserDetails = () => {
    setWarningText({});
    if (!isLdap) {
      setLdapUserName();
      const { firstName, lastName, email } = userDetails;
      if (firstName && firstName.length <= MAX_CHAR_LIMIT && (!lastName || (lastName && lastName.length <= MAX_CHAR_LIMIT)) && email && Validmail) {
        setCurrentStep(currentStep + 1);
      } else {
        setWarningText({
        firstName: !firstName ? 
        isEditable ? t(`${UPDATE_USER_MODAL}: ${updateTrans.EMPTY_FIRST_NAME_ERROR.key}`, updateTrans.EMPTY_FIRST_NAME_ERROR.value)
          : t(`${ADD_USER_MODAL}: ${addTrans.EMPTY_FIRST_NAME_ERROR.key}`, addTrans.EMPTY_FIRST_NAME_ERROR.value) 
        : firstName && (firstName.length > MAX_CHAR_LIMIT ? t(`${ADD_USER_MODAL}: ${addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.key}`, addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.value) : ''),
        lastName: lastName && (lastName.length > MAX_CHAR_LIMIT ? t(`${ADD_USER_MODAL}: ${addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.key}`, addTrans.MAX_CHAR_LIMIT_REACHED_ERROR.value) : ''),
          email: !userDetails.email
            ? t(addTrans.EMPTY_EMAIL_ERROR.key, addTrans.EMPTY_EMAIL_ERROR.value)
            : !Validmail
            ? t(addTrans.INVALID_EMAIL_ERROR.key, addTrans.INVALID_EMAIL_ERROR.value)
            : '',
        });
      }
    } else {
      setUserDetails([]);
      if (ldapUserName) {
        setCurrentStep(currentStep + 1);
      } else {
        setWarningText({
          ldapUser: t(addTrans.EMPTY_LDAP_USERNAME_ERROR.key, addTrans.EMPTY_LDAP_USERNAME_ERROR.value),
        });
      }
    }
  };
  const validateRolesTeams = () => {
    if (
      userDetails.roles?.length > 0 &&
      !TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role))
    ) {
      if (!isLdap) {
        saveUser();
      } else {
        saveLdapUser();
      }
      setWarningText({
        permission: '',
      });
    } else if (selectedIds?.length > 0 && userDetails.roles?.length > 0) {
      if (!isLdap) {
        saveUser();
      } else {
        saveLdapUser();
      }
    } else {
      setWarningText({
        roles: !userDetails.roles || userDetails.roles?.length === 0 ? 
        t(addTrans.EMPTY_ROLES_ERROR.key, addTrans.EMPTY_ROLES_ERROR.value) : '',
        permission: selectedIds?.length === 0 ? 
        t(addTrans.TEAM_PERMISSIONS_ERROR.key, addTrans.TEAM_PERMISSIONS_ERROR.value) : '',
      });
    }
    selectedIds?.length === 0 && setIsPermissionChanged(true);
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={
          isEditable ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {!isEditUserName ? (
                targetUser?.aType === 'ad' ? (
                  userDetails.displayName
                ) : (
                  userDetails.firstName +
                  ' ' +
                  (userDetails.lastName !== null ? userDetails.lastName : '')
                )
              ) : (
                <InputRow>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Input
                      className="userName"
                      size="large"
                      placeholder={t(`${UPDATE_USER_MODAL}: ${updateTrans.FIRST_NAME_PLACEHOLDER.key}`, updateTrans.FIRST_NAME_PLACEHOLDER.value)}
                      name="firstName"
                      value={userDetails.firstName}
                      onChange={handleChange}
                      autoComplete={'off'}
                    />
                    <WarningLabel editUser={1}>
                      {!userDetails.firstName ? t(`${UPDATE_USER_MODAL}: ${updateTrans.EMPTY_FIRST_NAME_ERROR.key}`, updateTrans.EMPTY_FIRST_NAME_ERROR.value) : ''}
                    </WarningLabel>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Input
                      className="userName"
                      size="large"
                      placeholder={t(`${UPDATE_USER_MODAL}: ${updateTrans.LAST_NAME_PLACEHOLDER.key}`, updateTrans.LAST_NAME_PLACEHOLDER.value)}
                      name="lastName"
                      value={userDetails.lastName}
                      onChange={handleChange}
                      autoComplete={'off'}
                    />
                    <WarningLabel> </WarningLabel>
                  </div>
                </InputRow>
              )}
              {targetUser?.aType !== 'ad' && (
                <Icon
                  style={{ fontSize: '14px', marginLeft: '10px' }}
                  type={!isEditUserName ? 'edit' : 'close-circle'}
                  onClick={() => setIsEditUserName(!isEditUserName)}
                />
              )}
            </div>
          ) : (
            t(addTrans.TITLE.key, addTrans.TITLE.value)
          )
        }
        visible={visible}
        width={1000}
        onCancel={onCancel}
        maskClosable={false}
        centered
        className="attachment_modal"
        footer={[
          <StepsAction nextBtn={currentStep === 0 && 1} isEditable={isEditable}>
            {currentStep === 0 && !isEditable && (
              <Button type="primary" onClick={() => validateUserDetails()}>
                {t(addTrans.NEXT_STEP_BUTTON.key, addTrans.NEXT_STEP_BUTTON.value)}
              </Button>
            )}
            {currentStep === 1 && (
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                onClick={() => setCurrentStep(currentStep - 1)}
              >
                {t(addTrans.PREVIOUS_STEP_BUTTON.key, addTrans.PREVIOUS_STEP_BUTTON.value)}
              </Button>
            )}
            {(currentStep === 1 || isEditable) && (
              <Button
                key="Add User"
                type="primary"
                loading={isLoading}
                onClick={!isEditable ? validateRolesTeams : validateUser}
                // style={{ width: '25%', margin: '-50px' }}
              >
                {isEditable
                  ? isLoading
                    ? t(updateTrans.UPDATING_BUTTON.key, updateTrans.UPDATING_BUTTON.value)
                    : t(updateTrans.UPDATE_BUTTON.key, updateTrans.UPDATE_BUTTON.value)
                  : isLoading
                  ? t(addTrans.SENDING_INVITE_BUTTON.key, addTrans.SENDING_INVITE_BUTTON.value)
                  : t(addTrans.INVITE_BUTTON.key, addTrans.INVITE_BUTTON.value)}
              </Button>
            )}
          </StepsAction>,
        ]}
      >
        <ModalBody>
          <AdduserSec
            className={!isEditable && 'adduserSec'}
            isStepTwo={currentStep === 1 && 1}
            initialConfig={isInitialLDAPConfig || userType === 'master'}
            isMaster={userType === 'master'}
          >
            {!isEditable && (
              <Steps current={currentStep}>
                {steps.map(item => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
            )}
            <ModalContainer user={1}>
              {currentStep === 0 && (
                <div>
                  {isEnterprise && !isEditable &&
                    currentStep === 0 &&
                    (userType !== 'master' && !isInitialLDAPConfig ? (
                      <div className="userOption">
                        <p onClick={() => setIsLdap(false)} className={!isLdap && 'selected'}>
                          {t(addTrans.DOC_USER_BUTTON.key, addTrans.DOC_USER_BUTTON.value)}
                        </p>
                        <p onClick={() => setIsLdap(true)} className={isLdap && 'selected'}>
                        {t(addTrans.LDAP_USER_BUTTON.key, addTrans.LDAP_USER_BUTTON.value)}
                        </p>
                      </div>
                      ) : (
                        <div className="userOption"></div>
                      ))}
                  {!isEditable && (
                    <SwitchTransition>
                      <CSSTransition
                        key={isLdap}
                        addEndListener={(node, done) => {
                          node.addEventListener('transitionend', done, false);
                        }}
                        classNames="fade"
                      >
                        <div>
                          <div className="user_input" addUser={!isEditable}>
                            {isLdap ? (
                              <InputRow addUser={!isEditable}>
                                <InputContainer
                                  className="full-width"
                                  user={1}
                                  addUser={!isEditable}
                                >
                                  <InputLabel>{t(addTrans.LDAP_USER_NAME_LABEL.key, addTrans.LDAP_USER_NAME_LABEL.value)}</InputLabel>
                                  <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder={t(addTrans.LDAP_USER_NAME_PLACEHOLDER.key, addTrans.LDAP_USER_NAME_PLACEHOLDER.value)}
                                    optionFilterProp="children"
                                    value={ldapUserName}
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={e => {
                                      setSelectedUser(e)
                                      setLdapUserName(e.displayName);
                                    }}
                                  >
                                    {ldapUsers.map(user => (
                                      <Option key={user.adid} value={user}>
                                        {user.displayName}
                                      </Option>
                                    ))}
                                  </Select>
                                  <WarningLabel>
                                    {!ldapUserName && warningText.ldapUser}
                                  </WarningLabel>
                                </InputContainer>
                              </InputRow>
                            ) : (
                              <>
                                {!isEditable && (
                                  <InputRow addUser={!isEditable}>
                                    <InputContainer
                                      className="full-width"
                                      user={1}
                                      addUser={!isEditable}
                                    >
                                      <InputLabel>{t(addTrans.FIRST_NAME_LABEL.key, addTrans.FIRST_NAME_LABEL.value)}</InputLabel>
                                      <Input
                                        size="large"
                                        placeholder={t(`${ADD_USER_MODAL}: ${addTrans.FIRST_NAME_PLACEHOLDER.key}`, addTrans.FIRST_NAME_PLACEHOLDER.value)}
                                        name="firstName"
                                        value={userDetails.firstName}
                                        onChange={handleChange}
                                        autoComplete={'off'}
                                      />
                                      <WarningLabel>
                                        {(!userDetails.firstName || warningText.firstName !== '') && warningText.firstName}
                                      </WarningLabel>
                                    </InputContainer>
                                    <InputContainer
                                      className="full-width"
                                      user={1}
                                      addUser={!isEditable}
                                    >
                                      <InputLabel>{t(addTrans.LAST_NAME_LABEL.key, addTrans.LAST_NAME_LABEL.value)}</InputLabel>
                                      <Input
                                        size="large"
                                        placeholder={t(`${ADD_USER_MODAL}: ${addTrans.LAST_NAME_PLACEHOLDER.key}`, addTrans.LAST_NAME_PLACEHOLDER.value)}
                                        name="lastName"
                                        value={userDetails.lastName}
                                        onChange={handleChange}
                                        autoComplete={'off'}
                                      />
                                      <WarningLabel>{(!userDetails.lastName || warningText.lastName !== '') && warningText.lastName}</WarningLabel>
                                    </InputContainer>
                                    <InputContainer user={1} addUser={!isEditable}>
                                      <InputLabel>{t(`${ADD_USER_MODAL}: ${addTrans.EMAIL_LABEL.key}`, addTrans.EMAIL_LABEL.value)}</InputLabel>
                                      <Input
                                        size="large"
                                        type="email"
                                        placeholder={t(`${ADD_USER_MODAL}: ${addTrans.EMAIL_PLACEHOLDER.key}`, addTrans.EMAIL_PLACEHOLDER.value)}
                                        name="email"
                                        value={userDetails.email}
                                        onChange={handleChange}
                                        autoComplete={'off'}
                                        disabled={targetUser?.aType === 'ad'}
                                      />
                                      <WarningLabel>{warningText.email}</WarningLabel>
                                    </InputContainer>
                                  </InputRow>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </CSSTransition>
                    </SwitchTransition>
                  )}
                </div>
              )}
              <InputRow>
                {isEditable && targetUser?.aType !== 'ad' && (
                  <InputContainer user={1} addUser={!isEditable} isMaster={userType === 'master'}>
                    <InputLabel>{t(`${UPDATE_USER_MODAL}: ${updateTrans.EMAIL_LABEL.key}`, updateTrans.EMAIL_LABEL.value)}</InputLabel>
                    <Input
                      size="large"
                      type="email"
                      placeholder={t(`${UPDATE_USER_MODAL}: ${updateTrans.EMAIL_PLACEHOLDER.key}`, updateTrans.EMAIL_PLACEHOLDER.value)}
                      name="email"
                      value={userDetails.email}
                      onChange={handleChange}
                      autoComplete={'off'}
                      disabled
                    />
                    <WarningLabel>{warningText.email}</WarningLabel>
                  </InputContainer>
                )}
                {(isEditable || currentStep === 1) && (
                  <InputContainer user={1} addUser={!isEditable} isMaster={userType === 'master'}>
                    <InputLabel
                      userRole={
                        ((!isEditable && currentStep === 1) || targetUser?.aType === 'ad') && 1
                      }
                    >
                      { isEditable ? t(`${UPDATE_USER_MODAL}: ${updateTrans.USER_ROLES_LABEL.key}`, updateTrans.USER_ROLES_LABEL.value) 
                      : t(`${ADD_USER_MODAL}: ${addTrans.USER_ROLES_LABEL.key}`, addTrans.USER_ROLES_LABEL.value) }
                    </InputLabel>
                    <Select
                      showSearch
                      size="large"
                      mode="multiple"
                      name="roles"
                      style={{ width: 200 }}
                      placeholder={ isEditable ?
                        t(`${UPDATE_USER_MODAL}: ${updateTrans.USER_ROLES_PLACEHOLDER.key}`, updateTrans.USER_ROLES_PLACEHOLDER.value) 
                        : t(`${ADD_USER_MODAL}: ${addTrans.USER_ROLES_PLACEHOLDER.key}`, addTrans.USER_ROLES_PLACEHOLDER.value) }
                      value={userDetails.roles}
                      onChange={roles => setUserDetails({ ...userDetails, roles })}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      className={'select-user-roles'}
                    >
                      {userRoleData.map((value, key) => {
                        return <Option key={key} value={value.id}>
                          {value.name}
                        </Option>
                      })}
                    </Select>
                    <WarningLabel>
                      {(!userDetails.roles || userDetails.roles?.length === 0) && warningText.roles}
                    </WarningLabel>
                  </InputContainer>
                )}
              </InputRow>
              {(isEditable || currentStep === 1) && (
                <InputRow>
                  <InputContainer
                    permission={1}
                    disabled={!TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role))}
                  >
                    <InputLabel permission={!isEditable && 1}>
                      { isEditable ? 
                      t(`${UPDATE_USER_MODAL}: ${updateTrans.TEAM_PERMISSIONS_LABEL.key}`, updateTrans.TEAM_PERMISSIONS_LABEL.value)
                      : t(`${ADD_USER_MODAL}: ${addTrans.TEAM_PERMISSIONS_LABEL.key}`, addTrans.TEAM_PERMISSIONS_LABEL.value)}</InputLabel>
                    <WarningLabel permission={1}>
                      {TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role)) &&
                      isPermissionChanged &&
                      selectedIds.length === 0
                        ? t(addTrans.TEAM_PERMISSIONS_ERROR.key, addTrans.TEAM_PERMISSIONS_ERROR.value)
                        : ''}
                    </WarningLabel>
                    <TeamPermission
                      selectedIds={selectedIds}
                      permissions={groupPermission}
                      selectedIndex={selectedIndex}
                      onSuccess={onSuccess}
                      isDisabled={
                        !TEAM_SELECTABLE_ROLES.some(role => userDetails.roles?.includes(role))
                      }
                    />
                  </InputContainer>
                </InputRow>
              )}
            </ModalContainer>
          </AdduserSec>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(AddUserModal);
